import type { ReceivedContent } from '@w/db-turso-browser-adapter/worker'
import { replicatedRows } from './workspace-tables'

// SHA-256 of exact stored CREATE SQL in the authoritative native bootstrap catalog.
// received-content-declarations.node.test.ts derives and certifies this on the vendored engine.
export const receivedContent: ReceivedContent[] = [{
  table: 'pages', columnOrdinal: 1,
  catalogFingerprint: Uint8Array.fromHex('d5e7e1c254e3af656af300e6deafbb17932bd62d304cd6b5faf9d950709b375a'),
}]

/** The columns that place each replicated table's rows in their access scope (a private row's owner, a shareable or attached
 * row's page, an edge's ends; workspace-tables.ts `replicatedRows`). The engine keeps them in the key image of a published
 * update or delete beside the primary key (fork ReplicaConfig::scope_columns), so the server authorizes the row from the
 * same columns its layouts read (transaction-row-codec.ts `workspaceScopeLayouts`). */
export const replicaScopeColumns = Object.entries(replicatedRows).flatMap(([table, row]) =>
  ('owner' in row ? [row.owner] : 'edge' in row ? row.edge : [row.page]).map(column => ({ table, column })))
